import styled from 'styled-components'

export const SignalIconImgWrap = styled.div<{ $size?: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${(p) => `${p.$size || 36}px`};
  height: ${(p) => `${p.$size || 36}px`};
`

export const SignalIconImg = styled.img`
  flex: none;
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  transform: translateZ(0);
`
